module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/summary/summary.component.css
// module id = ./src/app/sendMoney/summary/summary.component.css
// module chunks = main